import { useQuery } from '@tanstack/react-query';
import useGlynt from '../../hooks/useGlynt';

export function useRulesetSchema(dataPoolId: string, enabled: boolean = true) {
  const glynt = useGlynt();

  return useQuery({
    queryKey: ['ruleset-schema', dataPoolId],
    queryFn: async () => (await glynt).ruleset.schema(dataPoolId),
    enabled,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
